import { sessionAtom, useSettings } from '@capsicum/common';
import { useAtomValue } from 'jotai';
import React, { type PropsWithChildren } from 'react';

import { WalletConnectProviderOn } from './WalletConnectProviderOn';

export const WalletConnectProvider = ({ children }: PropsWithChildren) => {
	const {
		settings: { isWalletConnectEnabled }
	} = useSettings();
	const isLoggedIn = !!useAtomValue(sessionAtom)?.authToken;
	const isEnabled = isLoggedIn && isWalletConnectEnabled;

	return isEnabled ? <WalletConnectProviderOn>{children}</WalletConnectProviderOn> : children;
};
